import { useEffect } from "react";
import { api } from "~api";

const HEARTBEAT_INTERVAL_MS = 60000;

export function useAdminPresenceHeartbeat() {
  useEffect(() => {
    const ping = () => {
      api.post("/admin/presence/heartbeat").catch(() => undefined);
    };

    const pingWhenVisible = () => {
      if (!document.hidden) {
        ping();
      }
    };

    ping();
    const intervalId = window.setInterval(ping, HEARTBEAT_INTERVAL_MS);
    window.addEventListener("focus", pingWhenVisible);
    document.addEventListener("visibilitychange", pingWhenVisible);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", pingWhenVisible);
      document.removeEventListener("visibilitychange", pingWhenVisible);
    };
  }, []);
}
